import { render, staticRenderFns } from "./OdooClientInstanceTable.vue?vue&type=template&id=9cfa5318&scoped=true&"
import script from "./OdooClientInstanceTable.vue?vue&type=script&lang=js&"
export * from "./OdooClientInstanceTable.vue?vue&type=script&lang=js&"
import style0 from "./OdooClientInstanceTable.vue?vue&type=style&index=0&id=9cfa5318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfa5318",
  null
  
)

export default component.exports